<script setup>
import { ref, defineProps, defineEmits, defineExpose, computed, watch } from "vue";
import { useCsrCmpState } from "@/hooks/common/useCsrCmpState";
import { useAEMFetch } from "@/hooks/common/fetch/useFetch";
import { parseParams, transformPrice, sortData } from "@/utils/common";
import { isPhonePortrait } from "@/hooks/common/useUtils";
import { cloneDeep } from "lodash-es";
import { isEnableShopify } from "@/hooks/shopify-hooks/useShopifyConst";
import useHomeProperties from "@/hooks/common/useHomeProperties";
// import { useDispatchGAEvent } from "@/hooks/common/useDispatchGAEvent";
import { isNumEmpty }from '@/utils/tools.js'
const props = defineProps({
  stateKey: {
    type: String,
    default: "",
  },
  properties: {
    type: Object,
    default: () => {
      return {};
    },
  },
  isSearch: {
    type: Boolean,
    default: false,
  },
  keyWords: {
    type: String,
    default: null,
  },
});
const { symbol = "", symbolFirst = "true", priceFormat = "en", filterUnwind } = useHomeProperties();
const emitFuns = defineEmits(["filter", "search", "close"]);

const formatPrice = (price) => {
  if (price) {
    // aem 价格格式化, 处理千分符
    return transformPrice(price, priceFormat, "");
  } else {
    return price;
  }
};
// eslint-disable-next-line
const { state } = useCsrCmpState({
  stateKey: props.stateKey,
});
const { urlPrefix, version } = state.conf;
const activeNames = ref([]);
const filter = ref([]);
const filtershow = ref(true);
const form = ref({});
let isSubmit = isPhonePortrait();
const isEnableShopifyAbled = ref(isEnableShopify);

// 获取filter配置
const getProductFilter = async () => {
  //连接sit环境https://cms-sit-aem.midea.com
  let cacheUrl = `${urlPrefix}.filter.json`;
  if (version) {
    cacheUrl = `${urlPrefix}.filter.${version}.json`;
  }
  const { data } = await useAEMFetch(parseParams(cacheUrl)).get().json();
  filter.value = data.value;
  if (filter.value) {
    filter.value?.forEach((item) => {
      if (["2", "3", "4"].includes(item.filterType)) {
        if (item.filterType === "2" && item.filterValue.length) {
          item.filterValue = sortData(item.filterValue, "name");
        } else if (item.filterValue.length && item.valueType !== "1") {
          item.filterValue = sortData(item.filterValue, "value");
        }
      }
    });
  }
  initFilterData(filter.value || []);
};

// 初始化filter form值
const initFilterData = (filterData = []) => {
  const filterFormKeys = {};
  filterData?.forEach((item, index) => {
    const { filterType, filterTypeName } = item;
    // 库存
    if (filterType === "0") {
      filterFormKeys[filterTypeName] = false;
    }
    // 价格
    else if (filterType === "1") {
      filterFormKeys["priceRange"] = [];
      filterFormKeys["customPriceRange"] = ["", ""];
      activeNames.value.push(index);
    }
    // tag & full spec
    else if (["2", "3", "4"].includes(filterType)) {
      filterFormKeys[filterTypeName] = [];
      if (filterType === "2") {
        activeNames.value.push(index);
      }
    }
    // 其它
    else {
      filterFormKeys[filterTypeName] = "";
    }
    if(filterUnwind === '1' && !props.isSearch){
      activeNames.value.push(index);
    }else if(filterUnwind === '2' && !props.isSearch){
      activeNames.value=[];
    }
    
  });
  form.value = filterFormKeys;
};
if (isPhonePortrait()) {
  filtershow.value = false;
}
const reset = () => {
  initFilterData(filter.value);
  handleFilter();
};

// 当查询条件都为空时，emit暴露的数据为null
const handleFilter = () => {
  const isArrayEmpty = (arr) => {
    return arr instanceof Array && arr.filter((item) => !!item).length === 0;
  };
  const isEmpty = Object.values(form.value).every((item) => {
    return item === "" || item === false || isArrayEmpty(item);
  });
  let emitData = null;
  if (!isEmpty) {
    emitData = cloneDeep(form.value);
    if (emitData.customPriceRange) {
      const [customMinPrice = "", customMaxPrice = ""] =
        emitData.customPriceRange;
      if (customMinPrice || customMaxPrice) {
        emitData.priceRange.push(`${customMinPrice}|${customMaxPrice}`);
      }
      delete emitData.customPriceRange;
    }
  }

  if (!isSubmit) {
    emitFuns("filter", emitData);
    isSubmit = isPhonePortrait();
  }
};

// 监听filter事件
const changeCheckboxfunc = (val, key, label) => {
  if (val) {
    const strVal = label ? key + "-" + label : key;
    sendGaApply(strVal);
  }
  handleFilter();
};

// // 价格输入框ga埋码值处理
// const changePriceInput = (val, key, label) => {
//   if (val) {
//     let strVal = "";
//     if (key === "customPriceRange1") {
//       strVal = form.value["customPriceRange"][1]
//         ? `${label}-${symbol}${val}-${symbol}${form.value["customPriceRange"][1]}`
//         : `${label}-${symbol}${val}-NULL`;
//     } else if (key === "customPriceRange2") {
//       strVal = form.value["customPriceRange"][0]
//         ? `${label}-${symbol}${form.value["customPriceRange"][0]}-${symbol}${val}`
//         : `${label}-NULL-${symbol}${val}`;
//     }
//     sendGaApply(strVal);
//   }
//   handleFilter();
// };

// 发送ga埋码
const sendGaApply = () => {
  // eslint-disable-next-line
  if (isPhonePortrait()) return;
  // useDispatchGAEvent("__GA_CLICK_PLP_FILTER_CLICK__", {
  //   element: val,
  //   current_url: window.location.href,
  //   search_term: props.keyWords,
  // });
};

const formatSymbol = (price) => {
  return symbolFirst === "true" ? `${symbol}${price}` :  `${price}${symbol}`
}

// 合成价格区间ga值
const setPriceRangeLabel = (a, b) => {
  if (!isNumEmpty(a) && !isNumEmpty(b)) {
    return `${formatSymbol(a)}-${formatSymbol(b)}`;
  } else if (!isNumEmpty(a) && isNumEmpty(b)) {
    return `>=${formatSymbol(a)}`;
  } else if (isNumEmpty(a) && !isNumEmpty(b)) {
    return `<=${formatSymbol(b)}`;
  }
};

// 移动端提交filter
const submit = () => {
  filtershow.value = false;
  isSubmit = false;
  handleFilter();
  // useDispatchGAEvent("__GA_CLICK_PLP_SORTANDFILTER_CLICK__", {
  //   element: "Fifter",
  //   search_term: props.keyWords,
  // });
};

// 关闭移动端filter
const closeFunc = () => {
  filtershow.value = false;
  isSubmit = false;
  emitFuns("close");
};

const handlePriceRangeLabel = (filterItem) => {
  const priceRangeLabel = computed(() => {
    return `
      ${filterItem.minPrice && !filterItem.maxPrice ? "≥" : ""}
      ${!filterItem.minPrice && filterItem.maxPrice ? "≤" : ""}
      ${filterItem.minPrice ? formatSymbol(formatPrice(filterItem.minPrice)) : ""}
      ${filterItem.minPrice && filterItem.maxPrice ? " - " : ""}
      ${filterItem.maxPrice ? formatSymbol(formatPrice(filterItem.maxPrice)) : ""}
    `
  });
  return priceRangeLabel
}

watch(
  () => filtershow.value,
  (val) => {
     if (isPhonePortrait()) {
        $('body').css('overflowY', val ? 'hidden' : 'auto');
     }
  },
  {
    immediate: true,
  }
)

getProductFilter();
defineExpose({
  filtershow,
});
</script>
<template>
  <div v-show="filtershow" class="csr-product-list-v1__filter">
    <div class="csr-product-list-v1__filter-title">
      <span class="csr-product-list-v1__filter-title-text">{{
        properties?.filterText
      }}</span>
      <span class="csr-product-list-v1__filter-title-reset" @click="reset">
        <md-icon class="md-icon-refresh-right" name="edit"></md-icon
        >{{ properties?.resetText }}
      </span>
      <span class="csr-product-list-v1__filter-title-close" @click="closeFunc">
      </span>
    </div>
    <div class="csr-product-list-v1__filter-collapse" v-if="filter?.length">
      <md-collapse v-model="activeNames">
        <template v-for="(item, index) in filter">
          <!-- 库存 filterType = 0 -->
          <div v-if="item.filterType === '0'" v-show="isEnableShopifyAbled" :key="item.filterTypeName"
             class="csr-product-list-v1__filter-switch"
          >
            <span class="csr-product-list-v1__filter-switch-text">
              {{ item.filterTitle }}
            </span>
            <md-switch v-model="form[item.filterTypeName]" @change="(val) => changeCheckboxfunc(val, item.filterTitle, null)">
            </md-switch>
          </div>
          <md-collapse-item
            v-if="item.filterType !== '0'"
            :key="item.filterTypeName"
            :title="item.filterTitle"
            :name="index"
          >
            <!-- 价格 filterType = 1 -->
            <template v-if="item.filterType === '1'">
              <md-checkbox-group v-model="form['priceRange']">
                <md-checkbox v-for="(itm, idx) in item.priceRange"
                  :key="idx"
                  :label="`${itm.minPrice}-${itm.maxPrice}`"
                  @change="(val) => changeCheckboxfunc(val, item.filterTitle,setPriceRangeLabel(itm.minPrice, itm.maxPrice))"
                >
                {{ handlePriceRangeLabel(itm).value }}
                </md-checkbox>
              </md-checkbox-group>
              <!-- <div class="price-input">
                <md-input type="number" v-model="form['customPriceRange'][0]" controls-position="right"
                  @change=" (val) => changePriceInput(val, 'customPriceRange1', item.filterTitle)"
                  label="最小值"
                  :controls="false"
                >
                  <i slot="prefix">{{ symbol }}</i>
                </md-input>
                <span class="price-line"></span>
                <md-input type="number" v-model="form['customPriceRange'][1]" controls-position="right"
                  @change="(val) => changePriceInput(val, 'customPriceRange2', item.filterTitle)"
                  label="最大值"
                  :controls="false"
                >
                  <i slot="prefix">{{ symbol }}</i>
                </md-input>
              </div> -->
            </template>
            <!-- 颜色 filterType = 2 -->
            <md-checkbox-group v-else-if="item.filterType === '2'" v-model="form[item.filterTypeName]">
              <md-checkbox v-for="(itm, idx) in item.filterValue"
                :key="idx"
                :label="itm.value"
                @change="(val) => changeCheckboxfunc(val, item.filterTitle, itm.name)"
              >
                <i class="fills" :style="{ backgroundColor: itm.value }"> </i>
                {{ itm.name }}
              </md-checkbox>
            </md-checkbox-group>
            <!-- range Values -->
            <md-checkbox-group v-else-if="item.filterType === '3' && item.valueType === '1'" v-model="form[item.filterTypeName]">
              <md-checkbox
                v-for="(itm, idx) in item.rangeList"
                v-show="itm?.minValue || itm?.maxValue"
                :key="idx"
                :label="`${itm.minValue || null}|${itm.maxValue || null}/range`"
                @change="(val) => changeCheckboxfunc(val, item.filterTitle, itm.label)"
                >
                {{ itm.label }}
              </md-checkbox>
            </md-checkbox-group>
            <!-- tag & full spec filterType = 3 -->
            <md-checkbox-group v-else-if="item.filterType === '3' || item.filterType === '4'" v-model="form[item.filterTypeName]">
              <md-checkbox
                v-for="(itm, idx) in item.filterValue"
                :key="idx"
                :label="itm.value"
                @change="(val) => changeCheckboxfunc(val, item.filterTitle, itm.value)"
              >
                {{ itm.value }}
              </md-checkbox>
            </md-checkbox-group>
          </md-collapse-item>
        </template>
      </md-collapse>
    </div>
    <div class="csr-product-list-v1__filter-btn" v-if="isPhonePortrait()">
      <div class="csr-product-list-v1__filter-max-wrap">
        <button class="md-button md-button--L md-button--white" @click="reset">
          {{ properties?.resetText }}
        </button>
        <button class="md-button md-button--L md-button--primary" @click="submit">
          {{ properties?.confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>
